var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolume = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 5 6 9H2v6h4l5 4V5Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.07 4.93c3.904 3.905 3.904 10.235 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgVolume as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11 5L6 9H2V15H6L11 19V5Z' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M19.0703 4.92969C22.9741 8.83469 22.9741 15.1647 19.0703 19.0697' stroke='white' stroke-width='2' stroke-linecap='round'/%3E %3Cpath d='M15.5391 8.46094C17.491 10.4134 17.491 13.5784 15.5391 15.5309' stroke='white' stroke-width='2' stroke-linecap='round'/%3E %3C/svg%3E";